<div class="image-generation-container">
  <div class="header">
    <h2>Image Generation</h2>
  </div>

  <div class="content-area">
    <div class="image-display">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-container">
        <div class="spinner"></div>
        <p>Generating your image...</p>
      </div>

      <!-- Error Message -->
      <div *ngIf="errorMessage && !isLoading" class="error-container">
        <p class="error-message">{{ errorMessage }}</p>
        <button class="retry-btn" (click)="onSubmit()">Try Again</button>
      </div>

      <!-- Generated Image -->
      <div *ngIf="generatedImageUrl && !isLoading" class="image-container">
        <img [src]="generatedImageUrl" alt="Generated image" class="generated-image">
        <button class="clear-btn" (click)="clearImage()">Generate New Image</button>
      </div>

      <!-- Empty State -->
      <div *ngIf="!generatedImageUrl && !isLoading && !errorMessage" class="empty-state">
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <circle cx="8.5" cy="8.5" r="1.5"></circle>
          <polyline points="21 15 16 10 5 21"></polyline>
        </svg>
        <p>Enter a prompt below to generate an image</p>
      </div>
    </div>
  </div>

  <div class="input-area">
    <div class="model-selector">
      <button
        *ngFor="let model of models"
        class="model-btn"
        [class.active]="selectedModel === model.value"
        (click)="selectedModel = model.value"
        [disabled]="isLoading"
        type="button"
      >{{ model.label }}</button>
    </div>
    <div class="prompt-row">
      <input
        type="text"
        [(ngModel)]="prompt"
        (keypress)="onKeyPress($event)"
        placeholder="Describe the image you want to generate..."
        class="prompt-input"
        [disabled]="isLoading"
      >
      <button
        class="send-btn"
        (click)="onSubmit()"
        [disabled]="isLoading || !prompt.trim()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polygon points="5 3 19 12 5 21 5 3"></polygon>
        </svg>
      </button>
    </div>
  </div>
</div>

